import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

import './CalendlyCallback.scss';
import { Path } from '../../../routing';
import { useAuthContext, useInitCalendly } from '../../../data-access';

const CalendlyCallback: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const redirectTo = searchParams.get('redirectTo') ?? '';

  const { initCalendly } = useInitCalendly();

  const { user } = useAuthContext();

  useEffect(() => {
    if (!user?.userId) {
      return;
    }

    const init = async () => {
      await initCalendly({
        userId: user.userId,
        code,
        codeVerifier: sessionStorage.getItem('calendly_verifier') ?? '',
      });
      navigate(redirectTo || Path.DASHBOARD);
    };

    init();
  }, [user, redirectTo, code]);

  return (
    <div className="calendly-callback-page">
      <CircularProgress />
    </div>
  );
};

export default CalendlyCallback;
